import { lazy } from "react";

export default {
  name: "Diy",
  path: "/diy",
  component: lazy(() => import("./index"))
}